<template>
  <v-container>
    <div v-if="missingFields.length < 1">
      <p v-text="$t('completeUserData.everything-filled-in')"></p>
      <v-btn
          v-text="$t('completeUserData.everything-filled-in-button')"
          to="/dashboard"
      ></v-btn>
    </div>
    <v-form @submit="submitAdditionalUserDataForm" ref="additionalUserDataForm" v-else>
      <template v-for="(item, index) in missingFields">
        <v-select
            v-if="item === 'sex'"
            :key="index"
            :items="genderItems"
            v-model="formData[item]"
            :label="$t(`profile.${item}`)"
            required
            :rules="validationRules.required"
        ></v-select>
        <year-select
            v-else-if="item === 'year_of_birth'"
            v-model="formData[item]"
            :key="index"
            :label="$t(`profile.${item}`)"
            prepend-icon="mdi-pencil"
            validate-on-blur
            autocomplete="bday-year"
            :rules="validationRules.required"
            required
        ></year-select>
        <v-text-field
            v-else
            v-model="formData[item]"
            :key="index"
            :label="$t(`profile.${item}`)"
            :rules="validationRules.required"
            required
        ></v-text-field>
      </template>

      <v-row no-gutters>
        <v-col>
          <v-checkbox
              data-test-id="iam16minimum"
              v-model="minimum16yrsold"
              :disabled="loading"
              :rules="[v => !!v || $t('registration.i-am-min-16-years-old-required')]"
              :label="$t('registration.i-am-min-16-years-old')"
              required
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" sm="6" class="py-1">
          <v-btn @click="openAGBs" class="secondary darken-3">
            <v-icon left>mdi-open-in-app</v-icon>
            {{ $t('registration.show-legals') }}
          </v-btn>
          <AGBDialog
              :visible="showDialog.agb"
              :closeAction="function() {showDialog.agb = false;}"
          />
        </v-col>
        <v-col cols="12" sm="6" class="py-1">
          <v-btn
              @click="function() {showDialog.privacyPolicy = true;}"
              class="secondary darken-3"
          >
            <v-icon left>mdi-open-in-app</v-icon>
            {{ $t('registration.show-privacy-policy') }}
          </v-btn>
          <privacy-policy-dialog
              :visible="showDialog.privacyPolicy"
              :closeAction="function() {showDialog.privacyPolicy = false;}"
          />
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-3">
        <v-col>
          <v-checkbox
              data-test-id="acceptLegals"
              v-model="accept"
              :disabled="loading"
              :rules="[v => !!v || $t('registration.pp-and-legals-required')]"
              :label="$t('registration.i-accept-privacy-policy-and-legals')"
              required
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-checkbox
          data-test-id="acceptNewsletter"
          v-model="formData.is_subscriber"
          :disabled="loading"
          :label="$t('registration.i-subscribe-newsletter')"
      ></v-checkbox>
      <v-row justify="end" no-gutters>
        <v-btn type="submit" class="primary" :disabled="loading">
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { EVENT_REFRESH_DATA } from '@/plugins/eventbus'
import {
  ACTION_LOAD_PROFILE,
  MUTATION_RAISE_NOTIFICATION
} from '@/plugins/store'
import AGBDialog from '@/widgets/AGBDialog'
import PrivacyPolicyDialog from '@/widgets/PrivacyPolicyDialog'
import YearSelect from '@/widgets/YearSelect'

export default {
  name: 'CompleteUserData',
  components: {
    AGBDialog,
    PrivacyPolicyDialog,
    YearSelect
  },
  props: {
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      loading: false,
      accept: false,
      minimum16yrsold: false,
      formData: {
        is_subscriber: false
      },
      genderItems: [
        {
          value: 'm',
          text: this.$t('profile.salutation.m')
        },
        {
          value: 'f',
          text: this.$t('profile.salutation.f')
        }
      ],
      validationRules: {
        required: [v => !!v || this.$t('common.mandatory-field')]
      },
      showDialog: {
        agb: false,
        privacyPolicy: false
      }
    }
  },
  mounted() {
    this.refresh()
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.refresh)
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.refresh)
  },
  computed: {
    missingFields() {
      return this.$store.state.missingUserData.missingFields
    }
  },
  methods: {
    refresh() {
      this.loading = true
      this.$store.dispatch(ACTION_LOAD_PROFILE).finally(() => {
        this.loading = false
      })
    },
    submitAdditionalUserDataForm(e) {
      e.preventDefault()
      if (!this.$refs.additionalUserDataForm.validate()) {
        return
      }
      this.$api
          .patchProfile(this.formData)
          .then(() => {
            this.$router.push('/dashboard')
            this.loading = false
            this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
              type: 'success',
              message: this.$t('additionalUserData.successfully-updated-profile')
            })
          })
          .catch(error => {
            this.loading = false
            this.$common.onError(error)
          })
      return false
    },
    openAGBs() {
      this.showDialog.agb = true
    }
  }
}
</script>
